import { render, staticRenderFns } from "./BillDownload.vue?vue&type=template&id=2f28162f&scoped=true&"
import script from "./BillDownload.vue?vue&type=script&lang=js&"
export * from "./BillDownload.vue?vue&type=script&lang=js&"
import style0 from "./BillDownload.vue?vue&type=style&index=0&id=2f28162f&prod&scoped=true&lang=css&"
import style1 from "./BillDownload.vue?vue&type=style&index=1&id=2f28162f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28162f",
  null
  
)

export default component.exports